import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaskDefinitionService } from './logic/mask-definition.service';
import { MaskDefinitionLogicService } from './logic/mask-definition/mask-definition-logic.service';
import { MaskDefinitionDaoService } from './dao/mask-definition-dao.service';
import { MaskDefinitionStorageDaoService } from './dao/mask-definition-dao/mask-definition-storage-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: MaskDefinitionService, useClass: MaskDefinitionLogicService },
    { provide: MaskDefinitionDaoService, useClass: MaskDefinitionStorageDaoService }
  ]
})
export class MaskDefinitionModule {}
